"use strict";
require('reflect-metadata');
require('core-js/es6');
require('core-js/es7/reflect');
require('../shims/shims_for_IE');
require('zone.js/dist/zone');
require('ts-helpers');
var core_1 = require('@angular/core');
var platform_browser_dynamic_1 = require('@angular/platform-browser-dynamic');
var http_1 = require('@angular/http');
var ng2_redux_1 = require('ng2-redux');
var app_routes_1 = require('./app.routes');
var sample_app_1 = require('./containers/sample-app');
var services_1 = require('./services');
require('style!css!font-awesome/css/font-awesome.css');
if (__PRODUCTION__) {
    core_1.enableProdMode();
}
else {
    require('zone.js/dist/long-stack-trace-zone');
}
platform_browser_dynamic_1.bootstrap(sample_app_1.RioSampleApp, [
    ng2_redux_1.NgRedux,
    services_1.SoundService,
    services_1.SequenceService,
    http_1.HTTP_PROVIDERS,
    app_routes_1.APP_ROUTER_PROVIDERS,
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsUUFBTyxrQkFBa0IsQ0FBQyxDQUFBO0FBQzFCLFFBQU8sYUFBYSxDQUFDLENBQUE7QUFDckIsUUFBTyxxQkFBcUIsQ0FBQyxDQUFBO0FBQzdCLFFBQU8sdUJBQXVCLENBQUMsQ0FBQTtBQUMvQixRQUFPLG1CQUFtQixDQUFDLENBQUE7QUFDM0IsUUFBTyxZQUFZLENBQUMsQ0FBQTtBQUVwQixxQkFBd0MsZUFBZSxDQUFDLENBQUE7QUFDeEQseUNBQTBCLG1DQUFtQyxDQUFDLENBQUE7QUFDOUQscUJBQStCLGVBQWUsQ0FBQyxDQUFBO0FBRy9DLDBCQUF3QixXQUFXLENBQUMsQ0FBQTtBQUVwQywyQkFBcUMsY0FBYyxDQUFDLENBQUE7QUFFcEQsMkJBQTZCLHlCQUF5QixDQUFDLENBQUE7QUFDdkQseUJBR08sWUFBWSxDQUFDLENBQUE7QUFJcEIsT0FBTyxDQUFDLDZDQUE2QyxDQUFDLENBQUM7QUFFdkQsRUFBRSxDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQztJQUNuQixxQkFBYyxFQUFFLENBQUM7QUFDbkIsQ0FBQztBQUFDLElBQUksQ0FBQyxDQUFDO0lBQ04sT0FBTyxDQUFDLG9DQUFvQyxDQUFDLENBQUM7QUFDaEQsQ0FBQztBQUVELG9DQUFTLENBQUMseUJBQVksRUFBRTtJQUN0QixtQkFBTztJQUNQLHVCQUFZO0lBQ1osMEJBQWU7SUFDZixxQkFBYztJQUNkLGlDQUFvQjtDQUNyQixDQUFDLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.ts
 ** module id = 0
 ** module chunks = 1
 **/